import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { HERO_ICONS, QpxLogo } from '@quipex/shared/ui';

@Component({
    selector: 'qpx-splash',
    imports: [NgOptimizedImage, QpxLogo],
    templateUrl: './splash.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'qpx-splash',
    },
})
export class Splash {
    //#region Constants
    protected readonly errorImage = HERO_ICONS.barrier.md;
    //#endregion

    //#region Inputs
    public readonly isError = input(false);
    //#endregion
}
